import { useEffect, useState } from "preact/hooks";
import { h } from "preact";
import { CloseIcon } from "./CloseIcon";

export interface ModalComponentProps {
  show?: boolean;
  className?: string;
  title?: string;
  allowClose?: boolean;
  onClose?: () => void;
  content: h.JSX.Element | string;
}

export function Modal(props: ModalComponentProps) {
  const [show, setShow] = useState<boolean>(props.show ?? false);
  const allowClose = props.allowClose ?? true;

  useEffect(() => {
    if (props.show === undefined) {
      return;
    }
    setShow(props.show);
  }, [props.show]);

  return (
    <div
      className={`dark:bg-black dark:bg-opacity-80 bg-white bg-opacity-90 fixed inset-0 transition-opacity duration-500 ease-in-out ${
        show ? "!opacity-100" : "invisible opacity-0 -translate-y-full"
      }`}
    >
      <div
        className="flex items-center justify-center h-screen"
        onClick={(e) => {
          if (e.target === e.currentTarget && allowClose) {
            setShow(false);
            if (props.onClose) {
              props.onClose();
            }
          }
        }}
      >
        <div
          className={`bg-gray-50 dark:bg-[#181822] dark:text-gray-50 rounded-lg shadow-sm w-4/5 min-w-[300px] p-6 border border-gray-200 dark:border-gray-950 ${props.className}`}
        >
          <div className="flex justify-between items-center">
            {props.title && (
              <div className="m-0 text-base font-bold pb-4">{props.title}</div>
            )}
            {allowClose && (
              <button
                onClick={() => {
                  setShow(false);
                  if (props.onClose) {
                    props.onClose();
                  }
                }}
                className="hover:cursor-pointer hover:text-gray-400 text-gray-300 pb-4"
              >
                <CloseIcon />
              </button>
            )}
          </div>
          <div>{props.content}</div>
        </div>
      </div>
    </div>
  );
}
